import { Injectable, DestroyRef, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// modal-layout.service.ts
export type ModalSize = 'small' | 'normal' | 'wide' | 'full';

@Injectable({ providedIn: 'root' })
export class ModalLayoutService {
  private requests = new Map<string, ModalSize>();
  private _size$ = new BehaviorSubject<ModalSize>('normal');
  readonly size$ = this._size$.asObservable();

  setSize(key: string, size: ModalSize) {
    this.requests.set(key, size);
    this.emit();
  }
  clear(key: string) {
    this.requests.delete(key);
    this.emit();
  }
  reset() {
    this.requests.clear();
    this.emit();
  }

  setSizeUntilDestroyed(key: string, size: ModalSize, destroyRef: DestroyRef) {
    this.setSize(key, size);
    destroyRef.onDestroy(() => this.clear(key));
  }

  private emit() {
    // Prioridad: full > wide > small > normal
    let wantsFull = false,
      wantsWide = false,
      wantsSmall = false;
    for (const s of this.requests.values()) {
      if (s === 'full') {
        wantsFull = true;
        break;
      }
      if (s === 'wide') wantsWide = true;
      else if (s === 'small') wantsSmall = true;
    }
    const next: ModalSize = wantsFull
      ? 'full'
      : wantsWide
      ? 'wide'
      : wantsSmall
      ? 'small'
      : 'normal';
    this._size$.next(next);
  }
}
